import { graphql } from '../graphql';

export const updateUserMutation = graphql(`
  mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      id
      name
      mobileNumber
      avatar {
        id
        url
      }
    }
  }
`);

export const updatePasswordMutation = graphql(`
  mutation UpdatePassword($id: ID!, $input: UpdatePasswordInput!) {
    updatePassword(id: $id, input: $input)
  }
`);

export const deleteUserMutation = graphql(`
  mutation DeleteUser($id: ID!, $password: String!) {
    deleteUser(id: $id, password: $password)
  }
`);

export const updateEmailMutation = graphql(`
  mutation UpdateEmail($id: ID!, $email: String!) {
    updateEmail(id: $id, email: $email)
  }
`);

export const revokeSessionMutation = graphql(`
  mutation RevokeSession($sessionId: ID!) {
    revokeSession(sessionId: $sessionId)
  }
`);

export const updateThemeMutation = graphql(`
  mutation UpdateTheme($theme: ThemePreference!) {
    updateTheme(theme: $theme)
  }
`);

export const updateLanguageMutation = graphql(`
  mutation UpdateLanguage($language: String) {
    updateLanguage(language: $language)
  }
`);

export const updateViewerSettingsMutation = graphql(`
  mutation UpdateViewerSettings($input: ViewerSettingsInput!) {
    updateViewerSettings(input: $input)
  }
`);

export const saveOnboardingSurveyMutation = graphql(`
  mutation SaveOnboardingSurvey($data: JSON!) {
    saveOnboardingSurvey(data: $data)
  }
`);

export const setupTwoFactorMutation = graphql(`
  mutation SetupTwoFactor($mobileNumber: String!) {
    setupTwoFactor(mobileNumber: $mobileNumber) {
      secret
    }
  }
`);

export const verifyTwoFactorSetupMutation = graphql(`
  mutation VerifyTwoFactorSetup($secret: String!, $code: String!) {
    verifyTwoFactorSetup(secret: $secret, code: $code)
  }
`);

export const setupAuthenticatorTwoFactorMutation = graphql(`
  mutation SetupAuthenticatorTwoFactor {
    setupAuthenticatorTwoFactor {
      secret
      otpauthUri
    }
  }
`);

export const verifyAuthenticatorTwoFactorSetupMutation = graphql(`
  mutation VerifyAuthenticatorTwoFactorSetup($secret: String!, $code: String!) {
    verifyAuthenticatorTwoFactorSetup(secret: $secret, code: $code)
  }
`);

export const disableTwoFactorMutation = graphql(`
  mutation DisableTwoFactor($secret: String!, $code: String!) {
    disableTwoFactor(secret: $secret, code: $code)
  }
`);

export const disableAuthenticatorTwoFactorMutation = graphql(`
  mutation DisableAuthenticatorTwoFactor($code: String!) {
    disableAuthenticatorTwoFactor(code: $code)
  }
`);
